define([
    'lodash',
    'prop-types',
    'coreUtils',
    'componentsCore',
    'santa-components'
], function (_, PropTypes, coreUtils, componentsCore, santaComponents) {
    'use strict';

    const {createComponentSantaTypeFetcher} = coreUtils.propsSelectorsUtils;

    const {santaTypesDefinitions, utils: santaUtils} = santaComponents;

    /***** Refactor: This should seperated like visibility */
    const rawCss = createComponentSantaTypeFetcher((state, props) => {
        const compStyleData = state.fetchSantaType(santaTypesDefinitions.Component.theme, state, props);
        if (!compStyleData) {
            return '';
        }
        const themeData = state.fetchSantaType(santaTypesDefinitions.Theme.THEME_DATA, state, props);
        const isMobileView = state.fetchSantaType(santaTypesDefinitions.isMobileView, state, props);
        return state.siteAPI.getSiteAspect('stylableRenderingAspect').transpileStylesheet(compStyleData, themeData, props.id, isMobileView);
    });

    const getRawCss = createComponentSantaTypeFetcher(() => rawCss);

    const quickChangeOverrides = createComponentSantaTypeFetcher((state, props) => state.siteAPI.getSiteAspect('stylableRenderingAspect').getQuickChanges(props.id));
    const forceState = createComponentSantaTypeFetcher((state, props) => state.siteAPI.getSiteAspect('stylableRenderingAspect').getForceState(props.id));


    const fetchers = {
        rawCss,
        getRawCss,
        quickChangeOverrides,
        forceState
    };

    const NAMESPACE = 'Stylable';

    const definitions = santaUtils.createSantaTypesDefinitions({
        rawCss: PropTypes.string,
        getRawCss: PropTypes.func,
        quickChangeOverrides: PropTypes.shape({
            selector: PropTypes.string,
            declarationMap: PropTypes.string
        }),
        forceState: PropTypes.shape({
            selector: PropTypes.string,
            stateAttribute: PropTypes.string
        })
    }, NAMESPACE);

    componentsCore.santaTypesFetchersRegistry.registerFetchersNamespace(NAMESPACE, fetchers);

    return {
        fetchers,
        definitions
    };
});
